window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.applicationReceivedBox = window.locales.am.applicationReceivedBox || {};window.locales.am.applicationReceivedBox = {...window.locales.am.applicationReceivedBox, ...{
    "title": "ማመልከቻ ተቀብሏል።",
    "businessAdmin": "የንግድ መሠረቶች",
    "businessAnalytics": "MSBA መሠረቶች",
    "softwareEngineering": "የ MSSE መሠረቶች",
    "aiEngineering": "የ MSAIE መሠረቶች",
    "description": "ማመልከቻ ተቀብሏል! ለፕሮግራሙ ዝግጁ መሆንዎን ለማሳየት {playlistTitle} ያጠናቅቁ። መልካም ምኞት!",
    "descriptionFoundationsComplete": "ታላቅ ስራ! ማመልከቻህን በተመለከተ በቅርቡ ከእኛ ትሰማለህ።",
    "applied": "ተተግብሯል።",
    "decision": "ውሳኔ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.applicationReceivedBox = window.locales.ar.applicationReceivedBox || {};window.locales.ar.applicationReceivedBox = {...window.locales.ar.applicationReceivedBox, ...{
    "title": "تم استلام الطلب",
    "businessAdmin": "أسس الأعمال",
    "businessAnalytics": "مؤسسات MSBA",
    "softwareEngineering": "أسس MSSE",
    "aiEngineering": "أسس MSAIE",
    "description": "تم استلام طلبك! أكمل {playlistTitle} لإظهار استعدادك للبرنامج. بالتوفيق!",
    "descriptionFoundationsComplete": "عمل رائع! سنتواصل معك قريبًا بخصوص طلبك.",
    "applied": "مُطبَّق",
    "decision": "قرار"
}
};window.locales.en = window.locales.en || {};window.locales.en.applicationReceivedBox = window.locales.en.applicationReceivedBox || {};window.locales.en.applicationReceivedBox = {...window.locales.en.applicationReceivedBox, ...{
    "title": "Application Received",
    "businessAdmin": "Business Foundations",
    "businessAnalytics": "MSBA Foundations",
    "softwareEngineering": "MSSE Foundations",
    "aiEngineering": "MSAIE Foundations",
    "description": "Application received! Complete {playlistTitle} to demonstrate your readiness for the program. Good luck!",
    "descriptionFoundationsComplete": "Great work! You'll hear from us soon regarding your application.",
    "applied": "Applied",
    "decision": "Decision"
}
};window.locales.es = window.locales.es || {};window.locales.es.applicationReceivedBox = window.locales.es.applicationReceivedBox || {};window.locales.es.applicationReceivedBox = {...window.locales.es.applicationReceivedBox, ...{
    "title": "Solicitud recibida",
    "businessAdmin": "Fundamentos empresariales",
    "businessAnalytics": "Fundamentos de la MSBA",
    "softwareEngineering": "Fundamentos de MSSE",
    "aiEngineering": "Fundamentos de MSAIE",
    "description": "¡Solicitud recibida! Completa {playlistTitle} para demostrar que estás listo para el programa. ¡Mucha suerte!",
    "descriptionFoundationsComplete": "¡Buen trabajo! Pronto nos pondremos en contacto contigo para informarte sobre tu solicitud.",
    "applied": "Aplicado",
    "decision": "Decisión"
}
};window.locales.it = window.locales.it || {};window.locales.it.applicationReceivedBox = window.locales.it.applicationReceivedBox || {};window.locales.it.applicationReceivedBox = {...window.locales.it.applicationReceivedBox, ...{
    "title": "Domanda ricevuta",
    "businessAdmin": "Fondamenti aziendali",
    "businessAnalytics": "Fondamenti MSBA",
    "softwareEngineering": "Fondazioni MSSE",
    "aiEngineering": "Fondazioni MSAIE",
    "description": "Domanda ricevuta! Completa {playlistTitle} per dimostrare la tua preparazione per il programma. Buona fortuna!",
    "descriptionFoundationsComplete": "Ottimo lavoro! Presto riceverai nostre notizie in merito alla tua candidatura.",
    "applied": "Applicato",
    "decision": "Decisione"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.applicationReceivedBox = window.locales.zh.applicationReceivedBox || {};window.locales.zh.applicationReceivedBox = {...window.locales.zh.applicationReceivedBox, ...{
    "title": "申请已收到",
    "businessAdmin": "商业基础",
    "businessAnalytics": "MSBA 基础课程",
    "softwareEngineering": "MSSE 基础",
    "aiEngineering": "MSAIE 基础",
    "description": "申请已收到！请填写{playlistTitle} ，以证明您已准备好参加该项目。祝您好运！",
    "descriptionFoundationsComplete": "太棒了！我们很快就会收到你的申请回复。",
    "applied": "应用",
    "decision": "决定"
}
};